import axios from "axios";

const instance = axios.create({
  baseURL: "https://digitaljunction.hireho.com",
});

export default instance;
